"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "massa": {
    "4541c588": [{
      "hkey": "9f2d2b9e",
      "slug": "quercioli-rinchiostra",
      "name": "Quercioli-Rinchiostra",
      "primary": true,
      "skipSearch": false
    }],
    "quercioli-ringhiostra": [{
      "hkey": "9f2d2b9e",
      "slug": "quercioli-rinchiostra",
      "name": "Quercioli-Rinchiostra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2ce64b81": [{
      "hkey": "c6acd004",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-del-ponte-s-lucia": [{
      "hkey": "c6acd004",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "massa"
    }],
    "22eccfa5": [{
      "hkey": "c6acd004",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "c6acd004",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "massa"
    }],
    "2b7996e3": [{
      "hkey": "516a9f72",
      "slug": "marina-di-massa-centro",
      "name": "Marina di Massa Centro",
      "primary": true,
      "skipSearch": false
    }],
    "marina-di-massa": [{
      "hkey": "516a9f72",
      "slug": "marina-di-massa-centro",
      "name": "Marina di Massa Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fb6bc839": [{
      "hkey": "a6f1ad46",
      "slug": "massa",
      "name": "Massa",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "a6f1ad46",
      "slug": "massa",
      "name": "Massa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d7888cc": [{
      "hkey": "94171764",
      "slug": "poveromo-ronchi",
      "name": "Poveromo-Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "poveromo": [{
      "hkey": "94171764",
      "slug": "poveromo-ronchi",
      "name": "Poveromo-Ronchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1bef6776": [{
      "hkey": "94171764",
      "slug": "poveromo-ronchi",
      "name": "Poveromo-Ronchi",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi": [{
      "hkey": "94171764",
      "slug": "poveromo-ronchi",
      "name": "Poveromo-Ronchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "massa"
    }]
  }
};
exports["default"] = _default;